export default __webpack_public_path__ + "static/media/g9.d2f3e5d3.webp";